import { Box, Flex } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import styled from "styled-components"

import CollectionProduct from "areas/collection/jewlr/collection-product"

import ItemImage from "./item-image"
import Product from "./product"

const GridItem = styled(Box)`
  margin-bottom: 24px;
  padding: 0 8px;
  position: relative;
  text-align: center;
  ${(props) => props.theme.mediaQueries.tablet`
    margin-bottom: 24px;
  `}
`

const InternalCollectionItems = ({
  collection_items,
  lazyload,
  linkClickData,
}) => (
  <Flex flexWrap="wrap">
    {collection_items.map((item, index) => {
      if (item.type === "product") {
        return (
          <CollectionProduct
            index={index}
            key={`collection_item_${item.style_code || index}`}
            linkClickData={linkClickData}
            product={item}
          />
        )
      } else {
        // TODO: Need to use collection product component for LF as well
        const itemSize = 1
        return (
          <GridItem
            key={`collection_item_${item.style_code || index}`}
            width={{
              _: (item.style?.responsive_size?._ || itemSize) / 2,
              tablet: (item.style?.responsive_size?.tablet || itemSize) / 3,
            }}
          >
            {item.type === "product" && (
              <Product
                index={index}
                linkClickData={linkClickData}
                product={item}
              />
            )}
            {item.type === "image" && (
              <ItemImage
                image={item.image}
                lazyload={lazyload}
                linkClickData={linkClickData}
              />
            )}
          </GridItem>
        )
      }
    })}
  </Flex>
)

const mapStateToProps = (state, ownProps) => {
  const landing_element = state.landing.elements.find(
    (el) => el.id === ownProps.id
  )
  return {
    collection_items: landing_element ? landing_element.items : ownProps.items,
  }
}

const mapDispatchToProps = () => ({})

InternalCollectionItems.propTypes = {
  collection_items: PropTypes.arrayOf(PropTypes.object),
  id: PropTypes.string,
  lazyload: PropTypes.bool,
  linkClickData: PropTypes.string,
}

const CollectionItems = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalCollectionItems)

export default CollectionItems
